export { default } from './useMediaQuery';
export * from './useMediaQuery';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/useMediaQuery/index.js
// module id = 736
// module chunks = 22